import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./styles.css";
import { trackInitialPerformance } from "./utils/analytics";

trackInitialPerformance();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
